// 手机验证码登录
import { FC, useRef, useState } from 'react';
import styles from './index.module.less';
import { Form, Button, Modal } from 'antd';
import IconFont from '@/common/components/Base/IconFont';
import V2FormInput from '@/common/components/Form/V2FormInput/V2FormInput';
import V2Form from '@/common/components/Form/V2Form';
import GetCode from '@/common/components/business/GetCode';
// import { post } from '@/common/request/index';
import { MOBILE_REG } from '@lhb/regexp';
import { setStorage, setCookie } from '@lhb/cache';
import { fetchLogin, loginAndRegister } from '@/common/api/login';
import { ChangeModalStatus } from '../ts-config';
import Agreement from './Agreement';
import QyWxLogin from './QyWxLogin';
// import { useBigdataFn } from '@/common/utils/bigdata';
import { isArray } from '@lhb/func';
import { Link } from 'react-router-dom';
import KeepInfoModal from './KeepInfoModal';
import VoiceCaptcha from './VoiceCaptcha';

const CodeLogin: FC<ChangeModalStatus> = ({ setShowAccountModal, setModalVisible, setInfoData, form,
  isAutoRegister,
  setIsShareConfigToLogin
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const lockRef: any = useRef(false);
  const keepInfoModalRef = useRef<any>();
  const [open, setOpen] = useState<boolean>(false);

  const handleOk = () => {
    const values = form.getFieldsValue();
    handleLogin(values);
    setOpen(false);
  };

  // 信息填写完成填入cookie跳转到首页
  const onFinish = async (values: any) => {
    const { agree } = values || {};
    // 未勾选时，agree 是undefined，勾选后再取消勾选是Array
    if (!agree || (isArray(agree) && agree.length === 0)) {
      setOpen(true);
      return;
    }
    handleLogin(values);
  };

  const handleLogin = async(values) => {
    if (lockRef.current) return;
    lockRef.current = true;
    let targetFetch = fetchLogin;
    const params: any = {
      ...values
    };
    if (isAutoRegister?.isLoginAutoRegister && isAutoRegister?.tenantId) {
      targetFetch = loginAndRegister;
      params.tenantId = isAutoRegister.tenantId;
    }
    await targetFetch(params).then((data) => {
      // bigdataFn('42851518-803b-4a7e-bc8a-bad9c78ec6c9', '登录按钮', '点击了登录');
      // if代码块的逻辑废弃了，0815版本没有了试用账号注册的逻辑了
      if (data?.errCode === 'DE0519999601') {
        setInfoData({
          visible: true,
          mobile: values.mobile
        });
      } else if (data?.errCode === 'DE0519999602') { // 试用到期
        setModalVisible(true);
      } else {
        const { token, accountId } = data;
        if (token) {
          setStorage('flowLoginToken', token);
          setCookie('flow_account_id', accountId);
          // saas运营后台分享配置的链接登录的场景
          if (isAutoRegister?.isLoginAutoRegister && isAutoRegister?.tenantId) {
            setIsShareConfigToLogin({
              ...data,
              id: isAutoRegister.tenantId
            });
            return;
          }
          setShowAccountModal(true);
        }
      }
    }).finally(() => {
      // 这里加延时是因为setShowAccountModal的逻辑导致的，显示弹窗过程时，内部组件又有一个异步的逻辑，导致弹窗还未弹出时，按钮依然可以点击到
      setTimeout(() => {
        lockRef.current = false;
      }, 250);
    });
  };


  // 留资
  const onKeepInfo = (mobile?: string) => {
    keepInfoModalRef.current.init(mobile);
  };

  return (
    <div className={styles.codeLogin}>
      <V2Form form={form} onFinish={onFinish} validateTrigger={['onChange', 'onBlur']} size='large'>
        <V2FormInput
          name='mobile'
          rules={[
            { required: true, message: '请输入手机号' },
            { pattern: MOBILE_REG, message: '手机号格式错误' },
          ]}
          maxLength={11}
          config={{ autoComplete: 'on' }}
          prefix={<IconFont className={styles.icon} iconHref='iconic_phone' />}
          placeholder='请输入手机号'
        />
        {/* <p className={styles.usernameTips}>
          <IconFont className={styles.icon} iconHref='icon-warning_o' />
          <span>未注册手机验证后自动注册登录</span>
        </p> */}
        <V2FormInput
          name='code'
          rules={[{ required: true, message: '请输入验证码' }]}
          placeholder='请输入验证码'
          maxLength={6}
          prefix={<IconFont className={styles.icon} iconHref='iconic_password' />}
          // prefix={<IconFont className={styles.icon} iconHref='icon-ic_password' />}
          config={{
            suffix: <GetCode
              form={form}
              onKeepInfo={onKeepInfo}
              isSimple={isAutoRegister?.isLoginAutoRegister}
            />,
            className: styles.inputStyle,
          }}
        />
        <div className={styles.helpRow}>
          <VoiceCaptcha form={form}/>
          <div className={styles.onTrial}>
            还没有商户？
            <span className={styles.toOnTrial} onClick={() => onKeepInfo()}>免费试用</span>
          </div>
        </div>
        <Form.Item>
          <Button type='primary' htmlType='submit' block className={styles.submitBtn}>
            登录
          </Button>
        </Form.Item>
        {
          process.env.NODE_ENV === 'development' && false && <Button type='primary' block href='/pdf'>
          去PDF页
          </Button>
        }
        <Agreement/>
        <QyWxLogin
          setShowAccountModal={setShowAccountModal}
        />

      </V2Form>

      <Modal
        title='提示'
        okText='同意并登录'
        open={open}
        onOk={handleOk}
        onCancel={() => setOpen(false)}
      >
        <p>
          <IconFont iconHref={'iconwarning-circle1'} className='c-ff8 mr-8'/>
          登录前，请先阅读并同意
          <Link to='/openweb/service' className={styles.agreeBtn}>《用户协议》</Link>
          与
          <Link to='/openweb/privacy' className={styles.agreeBtn}>《隐私政策》</Link>
        </p>
      </Modal>

      {/* 留资弹窗 */}
      <KeepInfoModal ref={keepInfoModalRef}/>
    </div>
  );
};

export default CodeLogin;
